import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid } from 'semantic-ui-react';
import { LoginForm } from 'components';

import * as auth from 'actions/auth';
import * as form from 'actions/form';
import storage from 'helpers/storage';
import toastr from 'helpers/toastr';
import moment from 'moment-timezone';
import { auth as authClient } from 'helpers/auth';
import { AuthError } from '@vendys/web-lib';

import { getMeInfo } from 'apis/captainpayment';
import FindPasswordForm from '@/components/Login/FindPasswordForm';

import { GridWrapper } from './styles';

moment.tz.setDefault('Asia/Seoul');

class Login extends Component {
  constructor(props) {
    super(props);
    const info = storage.get('idSave');
    this.state = {
      idSave: info ? info.isChecked : false,
      id: '',
      isDim: false,
      isFindPassword: false
    };
  }

  componentWillMount() {
    // 세션 만료로 도착한 경우 안내 토스트
    if (sessionStorage.getItem('sessionExpiredNotice')) {
      sessionStorage.removeItem('sessionExpiredNotice');
      toastr('top-right', 'warning', '세션이 만료되었습니다. 다시 로그인해주세요.');
    }

    const info = storage.get('idSave');
    const { formAction } = this.props;

    this.setState({
      id: info && info.isChecked ? info.id : ''
    });

    if (info && info.isChecked) {
      formAction.changeInput({
        form: 'login',
        name: 'userID',
        value: info.id
      });
    }

    const password = storage.get('password');
    if (authClient.isAuthenticated() && (!password || password === 'NONE')) {
      const { state } = this.props.history.location;
      let url = '/service/landing';
      if (state) {
        url = '/main/dashBoard';
      }
      this.props.history.push({
        pathname: url,
        search: '',
        state
      });
    }
  }

  handleFindPassword = () => {
    this.setState({ isFindPassword: true });
  };

  handleFindPassword2 = () => {
    this.setState({ isFindPassword: false });
  };

  handleChange = (value, name) => {
    const { formAction } = this.props;

    formAction.changeInput({
      form: 'login',
      name,
      value
    });

    if (name === 'userID') {
      this.setState({ id: value });
    }
  };

  idSaveCheckbox = (e, data) => {
    this.setState({
      idSave: data.checked
    });
  };

  login = async () => {
    const { idSave } = this.state;
    const { form, authAction, history, location } = this.props;
    const { userID, userPWD } = form;

    if (!userID) {
      toastr('top-right', 'warning', '아이디를 입력해주세요.');
      return;
    }

    if (!userPWD) {
      toastr('top-right', 'warning', '비밀번호를 입력해주세요.');
      return;
    }
    // 로그인
    try {
      await this.setState({ isDim: true });
      const response = await authClient.login({ username: userID, password: userPWD, autoLogin: true }); // 기존 localStorage 유지
      const { account } = response;
      await this.setState({ isDim: false });

      storage.set('company', {
        userID: form.userID.toLowerCase(),
        companyInfo: ''
      });

      storage.set('idSave', {
        isChecked: idSave,
        id: idSave ? userID.toLowerCase() : null
      });

      const { state } = location;
      let search;
      let url = '/main/dashBoard';
      // change password
      if (account && account.password !== 'NONE') {
        storage.set('password', account.password);
        url = '/passwordChange';
        history.push({
          pathname: url,
          search: '',
          ...state,
          account
        });
      } else {
        storage.remove('password');
        const { duplicated } = account || {};
        const loginTime = authClient.getLoginTime();
        if (duplicated) {
          alert(`로그인 성공\n마지막 접속 일시: ${moment(loginTime).format('YYYY-MM-DD HH:mm:ss')}
다른 환경에서 동일한 아이디로 로그인되어 있어, 해당 로그인 상태는 강제로 로그아웃 처리 하겠습니다.`);
        } else if (loginTime) {
          alert(`로그인 성공\n마지막 접속 일시: ${moment(loginTime).format('YYYY-MM-DD HH:mm:ss')}`);
        }
        url = '/service/landing';
        if (state && state.from) {
          // direct url
          url = state.from.pathname;
          search = state.from.search;
        } else if (state) {
          // Invoice
          url = '/main/dashBoard';
        }

        const result = await getMeInfo();
        await authAction.mePaymentAPI();
        storage.set('companyInfo', { ...result.companyInfo });
        storage.set('company', {
          userID: form.userID.toLowerCase(),
          user: result.user,
          id: result.companyInfo.comId,
          info: result.user.company,
          list: result.company || []
        });

        history.push({
          pathname: url,
          search: search || '',
          state
        });
      }
    } catch (e) {
      await this.setState({ isDim: false });    
      const cause = (e instanceof AuthError ? e.cause : e) as {
        response?: { data?: { message?: string; error?: { message?: string } } };
      };
      const errorResult = cause && cause.response;
      const serverMessage =
        errorResult && errorResult.data && ((errorResult.data.error && errorResult.data.error.message) || errorResult.data.message);
      if (serverMessage) {
        toastr('top-right', 'warning', serverMessage);
      } else if (e instanceof AuthError && (e.kind === 'kms' || e.kind === 'rsa')) {
        toastr('top-right', 'warning', '인증 키 처리 중 오류가 발생했습니다. 페이지를 새로고침 해주세요.');
      } else {
        toastr('top-right', 'warning', '로그인 중 오류가 발생했습니다.');
      }
      console.log('###### e : ', e);
    }
  };

  render() {
    const { idSave, id, isDim, isFindPassword } = this.state;
    const { form } = this.props;
    return (
      <GridWrapper className="login" textAlign="center" style={{ alignItems: 'center' }}>
        {!isFindPassword ? (
          <LoginForm
            loginAction={this.login}
            handleChange={this.handleChange}
            onFindPassword={this.handleFindPassword}
            idSaveCheckbox={this.idSaveCheckbox}
            idSave={idSave}
            isDim={isDim}
            id={id}
          />
        ) : (
          <FindPasswordForm onFindPassword={this.handleFindPassword2} />
        )}
      </GridWrapper>
    );
  }
}

export default connect(
  (state) => ({
    company: state.auth.company,
    form: state.form.login
  }),
  (dispatch) => ({
    authAction: bindActionCreators(
      {
        meAPI: auth.meAPI,
        mePaymentAPI: auth.mePaymentAPI
      },
      dispatch
    ),
    formAction: bindActionCreators(
      {
        changeInput: form.changeInput
      },
      dispatch
    )
  })
)(withRouter(Login));
